// extracted by mini-css-extract-plugin
module.exports = {"id":"Personas_id__2CepQ","operations":"Personas_operations__2D2nz","userDetails":"Personas_userDetails__11FMZ"};